import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  control: {
    alignItems: "flex-start",
    cursor: "default",
    opacity: 1,

    "&:disabled": {
      cursor: "default",
      opacity: 1,
    },
  },

  anchor: {
    color: theme.colors.gray[6],

    "*": {
      color: "inherit",
    },
  },
}));
